import { TooltipContentWrapper } from '@components/atoms/Tooltip/Tooltip.styles';

const TooltipContent = (props: {
  boundaryElement: HTMLElement | undefined;
  popperElement: (value: ((prevState: null) => null) | null) => void;
  styles: { [p: string]: React.CSSProperties };
  attributes: { [p: string]: { [p: string]: string } | undefined };
  children: React.ReactNode;
}) => (
  <>
    {props.boundaryElement && (
      <TooltipContentWrapper
        ref={props.popperElement as any}
        style={props.styles.popper}
        {...props.attributes.popper}
        data-testid="tooltipContent"
      >
        {props.children}
      </TooltipContentWrapper>
    )}
  </>
);

export default TooltipContent;
